import React from 'react';
import { DisciplinaryRecords } from '@composite/disciplinary-records/disciplinary-record-fields';

export function DisciplinaryRecordFields() {
  return <DisciplinaryRecords />;
}
